import { OneInchCrossChainSDK, OneInchSingleChainSDK } from '../../one-inch-dev-portal/sdk';
import { SwapContextFusionPlusStrategy } from './swap-context-fusion-plus.strategy';
import { SwapContextFusionStrategy } from './swap-context-fusion.strategy';
import { SwapContextOnChainStrategy } from './swap-context-onchain.strategy';
export class SwapStrategyFactory {
    static createDefault(context, amountDataSource, swapSettings) {
        return [
            new SwapContextFusionPlusStrategy(new OneInchCrossChainSDK(context), amountDataSource, swapSettings),
            new SwapContextFusionStrategy(new OneInchSingleChainSDK(context), amountDataSource, swapSettings),
            new SwapContextOnChainStrategy(context.tokenRateProvider),
        ];
    }
}
//# sourceMappingURL=swap-strategy-factory.js.map